// extracted by mini-css-extract-plugin
export default {"pos-center":"Spinner_pos-center__AFTz2","loader":"Spinner_loader__yCPuB","spin":"Spinner_spin__xyVYo"};